import React from 'react';
import type { TopBannerListModel } from 'autogen/swagger/all';
import SimpleBannerList from 'components/topBanners/simpleBannerList';
import CarouselList from 'components/topBanners/carouselList';

interface ITopBannersProps {
    model: TopBannerListModel;
}

export const MainContext = React.createContext({});

function TopBanners({ model }: ITopBannersProps): JSX.Element {
    const { topBanners } = model;
    const singleBanner = topBanners.length === 1;

    return singleBanner ? <SimpleBannerList topBanners={topBanners} /> : <CarouselList topBanners={topBanners} />;
}

export default TopBanners;
